// Base URL (adjust based on your environment)
// export const API_BASE_URL = "http://localhost:4000";
export const API_BASE_URL = "https://www.ns8.microcodepgmt.com";

// Endpoints as constants or functions
export const ENDPOINTS = {
  login: `${API_BASE_URL}/user/login`,
  adminLogin: `${API_BASE_URL}/admin/login`,
  register: `${API_BASE_URL}/admin/register`,
  getStudent:`${API_BASE_URL}/user/get-user`,
  createQuiz:`${API_BASE_URL}/quiz/create-quiz`,
  deleteQuiz:`${API_BASE_URL}/quiz/delete-quiz`,
  getAllQuiz:`${API_BASE_URL}/quiz/get-all-quiz`,
  getAllQuizQuestions:`${API_BASE_URL}/quiz-question/get-question-of-quiz`,
  createQuizQuestions:`${API_BASE_URL}/quiz-question/create-question`,
  deleteQuizQuestions:`${API_BASE_URL}/quiz-question/delete-question`,
  scheduleQuiz:`${API_BASE_URL}/exam/schedule`,
  getScheduleQuiz:`${API_BASE_URL}/exam/get-all-exam`,
  deleteScheduleQuiz:`${API_BASE_URL}/exam/delete`,
  getUser:`${API_BASE_URL}/user/get-user`,
  createUser:`${API_BASE_URL}/user/sign-up`,
  getExam:`${API_BASE_URL}/user/get-exam`,
  submitExam:`${API_BASE_URL}/user/submit-exam`,
  getDashBoardData:`${API_BASE_URL}/admin/get-dashboard`,
  disableEnableButton:`${API_BASE_URL}/admin/disable-correct-answers`,
  getDisableEnableButton:`${API_BASE_URL}/admin/get-disable-correct-answers`,
  getAllUsers:`${API_BASE_URL}/admin/get-all-user`,
  uploadExcel:`${API_BASE_URL}/quiz-question/upload-excel`,
  sendOtpApi:`${API_BASE_URL}/admin/sendOtpEmail`,
  verifyOtpApi:`${API_BASE_URL}/admin/verifyOtp`,
  setPasswordApi:`${API_BASE_URL}/admin/resetPassword`,
  changePasswordApi:`${API_BASE_URL}/admin/change-password`,
  getAllQuizSubmissionApi:`${API_BASE_URL}/admin/get-quiz-submission-results`,

};

// Default export for easier import if you prefer
const api_endpoints = {
  ...ENDPOINTS
};

export default api_endpoints;
